let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7lf25")).then(() => parcelRequire('cYk97'));